export default __webpack_public_path__ + "static/media/KHInterference-Light.0d3c40de.otf";